// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"P3-z","displaySixCardTiles":"Q3-z"};